import { Lightning as lng, Log } from '@lightningjs/sdk';
import { Theme } from '../config/theme';

export class TestCmsPage extends lng.Component {
  static _template() {
    return {
      x: 0,
      y: 0,
      w: w => w,
      h: h => h,
      color: Theme.Colors.Transparent,
      rect: true,
      Label: {
        x: 800,
        y: 400,
        w: 600,
        h: 300,
        mount: 0.5,
        color: Theme.Colors.Menu.Active,
        text: {
          text: this.bindProp('label'),
          fontSize: 32,
          textAlign: 'center',
        },
      },
    };
  }

  _init() {
    this.label = this.params.name;
  }

  // _handleRight() {
  // }
  //
  // _handleLeft() {
  // }
  //
  _handleUp() {
    if (this.label === 'Guide') {
      Log.info('handle page up', this);
    }
  }
  //
  _handleDown() {
    if (this.label === 'Guide') {
      Log.info('handle page down', this);
    }
  }
  //
  // _handleEnter() {
  // }
  //
  // _handleBack() {
  //   return true;
  // }
}
